// eslint-disable-next-line import/prefer-default-export
export const errorCodes = {
  defaultSaveError: 'defaultSaveError',
  defaultRemoveError: 'defaultRemoveError',
  nameDuplicate: 'name.duplicate',
  conflict: 'conflict',
};
